export default __webpack_public_path__ + "static/media/CoreUI-Icons-Brand.65b45911.eot";